import AnimeInfo from 'features/animeInfo';

const RandomPage = () => (
  <AnimeInfo random />
);

export default RandomPage;
